import Constants from '../../constants';
import { redirectHyperLinks } from '../../utilities/helper';
import View from '../view';
import './index_web.css';

const FooterWeb = ({ footerBackground }: any) => {
  return (
    <View style={footerBackground} className="footer__wrapper__web">
      <View style={{ padding: '60px' }}>
        <View className="footer__header__sections__wrapper">
          <View className="footer__applications__header">Applications</View>
          <View className="footer__igamio__header">iGamio</View>
          <View className="footer__contactUs__header">Contact us</View>
        </View>
        <View className="footer__sections__wrapper">
          <View className="footer__applications__section">
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('whitelabelpokersoftware')}>
              White Label Poker Software
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('fantasysportspublisherintegration')}>
              Fantasy Sports Publisher Integration
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => {
                redirectHyperLinks('gamionetwork');
              }}>
              The Gamio Network
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => {
                redirectHyperLinks('gamiodevelopment');
              }}>
              Game Development
            </View>
          </View>
          <View className="footer__igamio__section">
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('aboutus')}>
              About Us
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('contactus')}>
              Contact us{' '}
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('careers')}>
              Careers
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('pokerarticles')}>
              Poker Articles
            </View>
            <View
              className="footer__sections__title__txt"
              onPress={() => redirectHyperLinks('fantasyarticles')}>
              Fantasy Articles
            </View>
          </View>
          <View className="footer__contactUs__section">
            <View className="footer__sections__title__txt">
              <Constants.Svgs.Phone
                className="footer_contactUs__icons"
                onClick={() => redirectHyperLinks('')}
              />
              +91 9311779940
            </View>
            <View className="footer__sections__title__txt">
              <Constants.Svgs.Email
                className="footer_contactUs__icons"
                onClick={() => redirectHyperLinks('')}
              />
              sales@gamiotech.com
            </View>
            <View className="footer__sections__title__txt">
              <Constants.Svgs.Website
                className="footer_contactUs__icons"
                onClick={() => redirectHyperLinks('igamio')}
              />
              www.gamiotech.com
            </View>
            <View className="footer__igamio__header follow__us__txt">Follow Us</View>
            <View className="footer__socialMedia__links">
              <img
                src={Constants.Images.instagram}
                onClick={() => redirectHyperLinks('instagram')}
              />
              <img src={Constants.Images.twitter} onClick={() => redirectHyperLinks('twitter')} />
              <img src={Constants.Images.youtube} onClick={() => redirectHyperLinks('youtube')} />
              <img src={Constants.Images.facebook} onClick={() => redirectHyperLinks('facebook')} />
              <img src={Constants.Images.linkedin} onClick={() => redirectHyperLinks('linkedin')} />
            </View>
          </View>
        </View>
      </View>
      <View className="footer__copyRights__txt">
        {'Copyright (c) 2022. iGamio Pvt Ltd. All rights reserved.'}
      </View>
    </View>
  );
};

export default FooterWeb;
